export const getAction = (type: string | undefined): any => {
  switch (type) {
    case 'replenishment':
    case 'payment':
      return 'Пополнить'
    default:
      return 'Купить'
  }
}
